<template>
	<div style="width:560px; height:480px;" v-on:keyup.esc="close()">
		<div class="view_inner">
			<div style="margin-bottom:5px; font-weight:bold;">
				{{ ship_to_code }} <span v-if="ship_to_name">- {{ ship_to_name }}</span>
				<br />
				<span style="font-weight:normal;">{{ item_code }} {{ item_name }}</span>
			</div>
			<div class="fixed-table-container" style="height:380px;">
				<div class="table-wrapper">
					<table class="list_tbl">
						<thead>
							<tr>
								<th style="text-align:center;width:130px;"><div class="th-text">Inv. No</div></th>
								<th style="text-align:center;width:90px;"><div class="th-text">Inv. Date</div></th>
								<th style="text-align:center;width:80px;"><div class="th-text">Qty</div></th>
								<th style="text-align:center;width:90px;"><div class="th-text">Price</div></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(row, index) in history" v-bind:key="index">
								<td class="al_left">
									<a href="javascript:;" @click="gotoInvoice(row)">{{ row.invoice_dn }}</a>
								</td>
								<td class="al_center">{{ row.invoice_date }}</td>
								<td class="al_right">{{ row.shipped_quantity | commaSeparated }}</td>
								<td class="al_right">{{ row.unit_price | toCurrency }}</td>
							</tr>
							<tr v-if="!loading && history.length === 0">
								<td colspan="4" class="al_center" style="padding:30px 0; color:#888;">No history.</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="view_bottom_bt">
				<a href="javascript:;" type="button" class="gray_bt" @click="close()">Close</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
import { apiSelectCustomerItemHistory } from '@/api/sales/invoice.js';

export default {
	name: 'CustomerItemHistoryPopup',
	props: {
		ship_to_code: String,
		ship_to_name: String,
		item_id: String,
		item_code: String,
		item_name: String,
	},
	data() {
		return {
			history: [],
			loading: false,
		};
	},
	methods: {
		async load() {
			if (!this.ship_to_code || !this.item_id) return;
			this.loading = true;
			try {
				const { data } = await apiSelectCustomerItemHistory({
					ship_to_code: this.ship_to_code,
					item_id: this.item_id,
				});
				this.history = data.customerItemHistory || [];
			} finally {
				this.loading = false;
			}
		},
		gotoInvoice(row) {
			let routeData = this.$router.resolve({
				name: 'invoiceDetail',
				params: { mode: 'detail' },
				query: { backUri: this.$route.fullPath, invoice_no: row.invoice_no },
			});
			window.open(routeData.href, 'herp_invoice');
		},
		close() {
			this.$emit('close');
		},
	},
	created() {
		this.load();
	},
};
</script>

<style></style>
